function dateFormat(datetime) {
  if (datetime == "") {
    return null;
  }
  const dateTime = new Date(Date.parse(datetime));

  const date = dateTime.toLocaleDateString();
  const time = dateTime.toLocaleTimeString();
  return date + " " + time;
}

function dateDiff(datetime) {
  const dt = new Date(Date.parse(datetime));
  const now = new Date();
  const diff = now.getTime() - dt.getTime();
  const sec = Math.floor(diff / 1000);
  let res = "";
  if (sec >= 60 * 60 * 24) {
    res = String(Math.floor(sec / 86400)) + " days";
  } else if (sec >= 60 * 60) {
    res = String(Math.floor(sec / 3600)) + " hours";
  } else if (sec >= 60) {
    res = String(Math.floor(sec / 60)) + " minutes";
  } else {
    res = sec + " sec";
  }
  return res;
}

function makeDate(bas) {
  var base = null;
  if (bas == null) {
    base = new Date();
  } else {
    base = new Date(bas);
  }
  base.setDate(base.getDate());
  const end =
    base.getFullYear().toString() +
    (base.getMonth() + 1).toString().padStart(2, "0") +
    base
      .getDate()
      .toString()
      .padStart(2, "0");
  const endStr =
    base.getFullYear().toString() +
    "/" +
    (base.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    base
      .getDate()
      .toString()
      .padStart(2, "0");

  base.setDate(base.getDate() + 1);
  const nextDate = base.toLocaleDateString();
  base.setDate(base.getDate() - 2);
  const prevDate = base.toLocaleDateString();

  const start =
    base.getFullYear().toString() +
    (base.getMonth() + 1).toString().padStart(2, "0") +
    base
      .getDate()
      .toString()
      .padStart(2, "0");
  const startStr =
    base.getFullYear().toString() +
    "/" +
    (base.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    base
      .getDate()
      .toString()
      .padStart(2, "0");

  return {
    start: start,
    end: end,
    startStr: startStr,
    endStr: endStr,
    nextDate: nextDate,
    prevDate: prevDate,
  };
}

function makeDate2(bas) {
  var base = null;
  if (bas == null) {
    base = new Date();
  } else {
    base = new Date(bas);
  }
  const startVal = new Date(base.getFullYear(), base.getMonth(), 1);
  const start =
    startVal.getFullYear().toString() +
    (startVal.getMonth() + 1).toString().padStart(2, "0") +
    "01";
  const startStr = startVal.toLocaleDateString();
  startVal.setMonth(startVal.getMonth() - 1);
  const prefDate = startVal.toLocaleDateString();
  startVal.setMonth(startVal.getMonth() + 2);
  const nextDate = startVal.toLocaleDateString();

  const endVal = new Date(base.getFullYear(), base.getMonth() + 1, 0);
  const end =
    endVal.getFullYear().toString() +
    (endVal.getMonth() + 1).toString().padStart(2, "0") +
    endVal
      .getDate()
      .toString()
      .padStart(2, "0");
  const endStr = endVal.toLocaleDateString();
  return {
    start: start,
    end: end,
    startStr: startStr,
    endStr: endStr,
    prevDate: prefDate,
    nextDate: nextDate,
  };
}

function makeDate3(bas) {
  var base = null;
  if (bas == null) {
    base = new Date();
  } else {
    base = new Date(bas);
  }
  base.setDate(base.getDate());
  const today =
    base.getFullYear().toString() +
    (base.getMonth() + 1).toString().padStart(2, "0") +
    base
      .getDate()
      .toString()
      .padStart(2, "0");
  const todayStr =
    base.getFullYear().toString() +
    "/" +
    (base.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    base
      .getDate()
      .toString()
      .padStart(2, "0");
  base.setDate(base.getDate() + 1);
  const nextDate = base.toLocaleDateString();
  base.setDate(base.getDate() - 2);
  const prevDate = base.toLocaleDateString();

  return {
    today: today,
    todayStr: todayStr,
    nextDate: nextDate,
    prevDate: prevDate,
  };
}

function makeDate4(bas) {
  var base = null;
  if (bas == null) {
    base = new Date();
  } else {
    base = new Date(bas);
  }
  const startStr =
    base.getFullYear().toString() +
    "/" +
    (base.getMonth() + 1).toString().padStart(2, "0") +
    "/01";
  const startDate = startStr.replace(/\//g, "");

  const nd = new Date(base.getFullYear(), base.getMonth() + 1, 1);
  const nextDate =
    nd.getFullYear().toString() +
    "/" +
    (nd.getMonth() + 1).toString().padStart(2, "0") +
    "/01";

  const pd = new Date(base.getFullYear(), base.getMonth() - 1, 1);
  const prevDate =
    pd.getFullYear().toString() +
    "/" +
    (pd.getMonth() + 1).toString().padStart(2, "0") +
    "/01";

  const enddate = new Date(base.getFullYear(), base.getMonth() + 1, 0);
  const endStr =
    enddate.getFullYear().toString() +
    "/" +
    (enddate.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    enddate
      .getDate(0)
      .toString()
      .padStart(2, "0");
  const endDate = endStr.replace(/\//g, "");

  return {
    startDate: startDate,
    startStr: startStr,
    endDate: endDate,
    endStr: endStr,
    nextDate: nextDate,
    prevDate: prevDate,
  };
}

export default {
  dateFormat,
  dateDiff,
  makeDate,
  makeDate2,
  makeDate3,
  makeDate4,
};
